/**
 * Utility functions for color manipulation and detection
 */

/**
 * Determines if a color is light (for text contrast purposes)
 * @param {string} hexColor - Hex color code (with or without # prefix)
 * @returns {boolean} true if the color is light, false if dark
 */
export const isLightColor = (hexColor) => {
    // Handle null or undefined input
    if (!hexColor) return true;

    // Remove the hash if it exists
    const hex = hexColor.replace('#', '');

    // Convert hex to RGB
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    // Calculate brightness (perceived brightness formula)
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // Return true if the color is light
    return brightness > 155;
};

/**
 * Generates text color (black or white) based on background color for optimal contrast
 * @param {string} backgroundColor - Hex color code for background
 * @returns {string} '#000000' for dark text or '#FFFFFF' for light text
 */
export const getContrastTextColor = (backgroundColor) => {
    return isLightColor(backgroundColor) ? 'rgba(0, 0, 0, 0.87)' : '#FFFFFF';
};